import React from "react";
import Paper from "@material-ui/core/Paper";
import IconButton from "@material-ui/core/IconButton";
import World from "./world";

import { KeyboardArrowDown } from "@material-ui/icons";
export default class Landing extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div style={{ marginTop: 35 }}>
        <Paper
          elevation={0}
          square={true}
          style={{
            height: "90vh",
            backgroundColor: "white",
            display: "flex",
            flexDirection: "column"
          }}
        >
          <div
            style={{
              display: "flex",
              flex: 4,
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center",
              zIndex: 1
            }}
          >
            <b style={{ fontSize: "5vmax" }}>CONNECTING THE WORLD</b>
          </div>
          <div
            style={{
              display: "flex",
              flex: 5,
              flexDirection: "column",
              justifyContent: "flex-end",
              alignItems: "center"
            }}
          >
            <World style={{ zIndex: 3 }} />
          </div>
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "center"
            }}
          >
            <a href="#intro" style={{ textDecoration: "none", color: "black" }}>
              <IconButton color="inherit" aria-label="Menu">
                <KeyboardArrowDown style={{ fontSize: 50 }} />
              </IconButton>
              <p />
            </a>
          </div>
        </Paper>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/landing.js